<template>
  <div class="login-contain">
   
    <div class="login-form">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
      >
        <div class="login-logo">
          <!-- <img src="~assets/img/logo.png" alt="" > -->
          <div class="title">AIFENIX</div>
        </div>
        <div class="login-form-tip">T.I.M System</div>
        <el-form-item  prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            autocomplete="off"
            placeholder="Username"
            class="login-input"
          ></el-input>
        </el-form-item>
        <el-form-item  prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            show-password
            placeholder="Password"
            class="login-input"
          ></el-input>
        </el-form-item>
        <el-form-item class="btn-group">
          <el-button @click="submitForm('ruleForm')"  type="primary">Login</el-button>
          <br>
          <router-link to="/forgot_password" class="forgot">Forgot Password</router-link>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      T.I.M ©2023 Powered by Nextan
    </div>
  </div>
</template>

<script>
import { login } from "network/login"
import { setToken } from "common/auth"
export default {
  name: "Login",
  data() {
    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input username."));
      } else {
        callback()
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input password."));
      } else {
        callback()
      }
    };
    return {
      ruleForm: {
        outlet: "",
        username: "",
        password: "",
      },
      rules: {
        outlet: [{ trigger: "blur" }],
        username: [{ validator: validateUsername, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
      },
    };
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const subData = {
            username: this.ruleForm.username,
            password: this.ruleForm.password
          }

          login(subData)
            .then( data => {
              if (data.status === 200) {
                const inData = data.data
                sessionStorage.setItem("username", inData.username)
                sessionStorage.setItem("role", inData.role)
                sessionStorage.setItem("refresh", inData.refresh)
                setToken(inData.access)
                 
                this.$router.push("/")
              } 
          }).catch( err => {
            this.$message.error("Please enter the correct usename and password.");
          })
        } 
      })
    }
  },
};
</script>

<style scoped>
.login-contain {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: url(../../assets/img/login_bg.png) no-repeat center;
  background-size: 100% auto;
}

.login-contain .login-form {
  position: relative;
  opacity: 0.9;
  
  
}
.login-contain .login-form .el-form {
  position: relative;
  width: 400px;
  height: 420px;
  padding: 20px 36px 36px;
  background-color: #3c5b7a;
  border-radius: 10px;
  z-index: 50;
}
.login-contain .login-logo {
  margin: 20px 0 20px;
  text-align: center;
}
.login-contain .login-logo .title{
  font-size: 40px;
  color: #fff;
}

.login-contain .login-form .login-form-tip {
  color: #fff;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 30px;
}
.login-contain .login-form .el-form-item {
  margin-bottom: 28px;
}
.login-form .btn-group {
  text-align: center;
}
.login-form .btn-group button {
  width: 100%;
}
.login-form .forgot{
  float: right;
  color: #dbdbdb;
}
.login-contain .footer{
  position: absolute;
  bottom: 20px;
  color: #fff;
  font-size: 18px;
  font-style: oblique;
}
</style>
